<template>
  <div class="match-highlight">
    <div class="empty" v-if="isEmpty(highlight) || isEmpty(highlight.highlight)">
      <MatchNotFound :title="'하이라이트'" style="margin: 0" />
    </div>
    <div class="video-frame" v-else>
      <iframe width="100%" height="315"
              :src="highlight.highlight"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
import {isEmpty} from '@/lib';
import MatchNotFound from '@/components/Ticket/MatchNotFound.vue';

export default {
  name: 'MatchHighlight',
  components: {MatchNotFound},
  props: {
    highlight: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {

    }
  },
  mounted () {
  },
  methods: {
    isEmpty

  }
}
</script>
